/* eslint-disable import/prefer-default-export */
import { Response } from '../models/shared';

const transformResponseData = <T>(response: Response<T>): (T | null) => response.data || null;

export { transformResponseData };
